<template>
<div >

<spinner v-bind:spinner='spinner'></spinner>

  <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <div v-if="type=='A'">

  <div class="card ">

  <div class="card-header text-white bg-info">
    <h4><i  class="	far fa-address-card mr-2" aria-hidden="true"></i>ANAGRAFICA FORNITORI</h4>
  </div>


  <div  class="card-body"> 

      <button type="button" @click="type='B'" class="btn btn-success mb-2 ">
      <i  class="fas fa-user-plus mr-2" aria-hidden="true"></i>
      NUOVO FORNITORE</button> 

  
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table class="table table-hover table-striped mb-0">
    <thead class="cart">
      <tr class="table-primary">
      
        <th scope="col">#</th>
        <th scope="col"></th>
        <th scope="col">FORNITORE</th>
        <th scope="col">PARTITA IVA</th>
        <th scope="col">CODICE FISCALE</th>
        <th scope="col">TELEFONO</th>
        <th scope="col">CONTATTO</th>
        <th scope="col">eMAIL</th>
    
      </tr>
    </thead>
    <tbody>
      <tr  class="pointer" v-for="(item, index) in filteredItems" :key="index">
      
        <td>{{index+1}}</td>
         <td>
            <i @click="edit(item)" class="far fa-edit" aria-hidden="true"></i>
          
        </td>
        <td><strong>{{item.supplier}}</strong></td>
        <td>{{item.vat_number}}</td>
        <td>{{item.fc}}</td>
        <td>{{item.tel}}</td>
        <td>{{item.contact}}</td>
        <td>{{item.email}}</td>
      </tr>  
    </tbody>
  </table>
  
  
  </div>


  <div class="form-group mt-5">
  <label for="cerca"><strong>Filtra</strong></label>
  <input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">
  </div>

  </div>

</div>


</div>

<div v-else>
  
  <supplier @close="type='A',getData(),item={}" v-bind:item="item"></supplier>
  
</div>  


</div>



</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';

import alertBox          from '@/components/common/AlertBox.vue';
import supplier          from '@/components/supplier/Supplier.vue' 
import spinner           from '@/components/common/Spinner.vue' 

export default {
  components: {alertBox,supplier,spinner},
  data() {
    return {
      
      type                   : 'A',
      items                  : [],
      item                   : {},
      spinner                : false, 
      filterKey              : '',     
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
      
     
     
     
    };
  },
  computed :{
     ...mapGetters(['company']),
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
   
   
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted: function() {
    //this.getData()
  },
  created: function() {
    this.getData()
  },
  methods: 
  {
    edit(item)
    {
      this.item = item
      this.type = 'B'
      

    },
    async getData()
    {

      this.msg.title = ''
     
      this.spinner = true
      var sp   = {'sp'    : 'spSupplierList'}
      var data = {'companyId' : this.company.Id}
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items   = res.data.recordsets[0]  
            /*
            if(this.items.length==0)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
            } 
            */      

          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1
          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1                 
          } 
      }).catch(err => 
      {
        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type = 1
      }).finally(() => {
        this.spinner = false
      });
     
    
    },
  
    close()
    {
      
      this.$emit('close')
    },
    setSupplier(item)
    {
     
    }
  
}

}
</script>
<style scoped>




.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    

 }
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.cart th:last-child {
  border-radius: 0 12px 0 0;
}
.cart th:first-child {
  border-radius: 0 0 0 12px;
}
</style>